import { render, staticRenderFns } from "./FeatureItem.vue?vue&type=template&id=758dad24&scoped=true"
import script from "./FeatureItem.vue?vue&type=script&lang=js"
export * from "./FeatureItem.vue?vue&type=script&lang=js"
import style0 from "./FeatureItem.vue?vue&type=style&index=0&id=758dad24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758dad24",
  null
  
)

export default component.exports